<template>
  <v-container fluid grid-list-xl class="mt-0 pt-0">
    <v-layout wrap>
      <v-flex xs12>
        <v-layout justify-space-between class="ml-6 mr-6">
          <v-snackbar
            v-if="!getCurrentDevice.uptime.serial"
            :timeout="-1"
            :value="true"
            absolute
            centered
            top
            color="error"
            elevation="24"
            class="runningImage"
          >
            {{ $t("err.device.serial") }}
          </v-snackbar>

          <v-btn @click="back()" exact color="primary" class="ma-2">
            <v-icon left>arrow_back</v-icon>
            {{ $t("common.back") }}
          </v-btn>

          <v-layout justify-end class="ma-0 pa-0">
            <v-btn @click="alarmOnDemand()" exact color="primary" class="ma-2">
              <v-icon left>mdi-bell-ring</v-icon>
              {{ $t("device.alarmondemand") }}
            </v-btn>

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="ma-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>mdi-camera</v-icon>
                  {{ $t("device.snapshot") }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in cameras"
                  :key="index"
                >
                  <v-list-item-content @click="takeSnapshot(item.id)">{{ item.name }}</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-tooltip bottom :disabled="connectedUsers == null">
              <template v-slot:activator="{ on, attrs }">
                <v-badge
                  bordered
                  color="warning"
                  overlap
                  :content="connectedUsersNumber"
                  class="ma-2"
                >
                  <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    
                  >
                    <v-icon left>mdi-account-group</v-icon>
                    {{ $t("device.connectedusers") }}
                  </v-btn>
                </v-badge>
              </template>
              <span v-html="connectedUsers"></span>
            </v-tooltip>
          </v-layout>

        </v-layout>

        <v-dialog v-model="showSnapshot" @click:outside="snapshotUrl = null">
          <v-card color="primary">
            <v-card-text class="pa-0">
              <v-img v-if="snapshotUrl" :src="snapshotUrl" :aspect-ratio="16/9" width="1300"></v-img>
              <div v-else class="pa-4">
                <span class="loadingtext">{{ $t("device.takingsnapshot") }}</span>
                <v-progress-linear
                  indeterminate
                  color="white" 
                  height="5" 
                  class="mt-1 mb-0"
                ></v-progress-linear>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showAutomaticSnapshot" @click:outside="showAutomaticSnapshot = false">
          <v-card>
            <v-card-title class="primary--text">{{ $t("device.automaticsnapshot") }}</v-card-title>
            <v-card-text class="pa-0">
              <v-carousel v-model="carouselModel">
                <v-carousel-item
                  v-for="snapshot in getCurrentDevice.automaticSnapshots"
                  :key="snapshot.img"
                >
                  <v-img :src="snapshot.img" :aspect-ratio="16/9" width="1300"></v-img>
                </v-carousel-item>
              </v-carousel>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-tabs v-model="tab" centered class="pb-2">
          <v-tab v-for="tabItem in deviceTab" :key="tabItem">
            {{ tabItem }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <sae-interface></sae-interface>
          </v-tab-item>
          <v-tab-item>
            <device-data></device-data>
          </v-tab-item>
          <v-tab-item v-if="false">
            <v-card flat>
              <v-card-text>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-row wrap class="ma-2">
                      <device-historical-data
                        v-for="graph in getKpi.filter((k) => !k.startsWith('ACC'))"
                        :key="graph"
                        :kpi="graph"
                      ></device-historical-data>
                    </v-row>
                  </v-layout>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <device-alarm></device-alarm>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from  "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import DeviceData from "./DeviceData.vue";
import SaeInterface from "./SaeInterface.vue";
import DeviceHistoricalData from "./DeviceHistoricalData.vue";
import DeviceAlarm from "./DeviceAlarm.vue";

export default {
  props: ["openAlarms"],
  components: {
    DeviceData,
    SaeInterface,
    DeviceHistoricalData,
    DeviceAlarm,
  },
  data() {
    return {
      tab: 0,
      deviceTab: [
        this.$i18n.t('device.sae.title'), 
        this.$i18n.t('device.sensor.title'),
        // this.$i18n.t("device.historicaldata.title"),
        this.$i18n.t("device.alarmhistory.title"),
      ],
      cameras: [
        { id: "DVR-001", name: "Camera 1" },
        { id: "DVR-002", name: "Camera 2" },
        { id: "DVR-003", name: "Camera 3" },
      ],
      showSnapshot: false,
      snapshotUrl: null,
      showAutomaticSnapshot: false,
      carouselModel: 2
    };
  },
  mounted() {
    if (this.openAlarms) this.tab = 3;
  },
  computed: {
    ...mapGetters(["getKpi", "getDevicesUsers", "getCurrentDevice"]),
    connectedUsers() {
      if (this.getDevicesUsers[this.getCurrentDevice.deviceId]) {
        this.$log.debug(this.getDevicesUsers[this.getCurrentDevice.deviceId])
        this.$log.debug(this.getDevicesUsers[this.getCurrentDevice.deviceId].toString())
        this.$log.debug(this.getDevicesUsers[this.getCurrentDevice.deviceId].toString().replaceAll(",","<br>"))
        return this.getDevicesUsers[this.getCurrentDevice.deviceId].toString().replaceAll(",","<br>")
      }
      return null
    },
    connectedUsersNumber() {
      if (this.getDevicesUsers) {
        if (this.getDevicesUsers[this.getCurrentDevice.deviceId])
          return this.getDevicesUsers[this.getCurrentDevice.deviceId].length
      } 
      return 1
    },
    currentAutomaticSnapshot() {
      if (this.getCurrentDevice) {
        if (this.getCurrentDevice.automaticSnapshots)
          return this.getCurrentDevice.automaticSnapshots
      }
      return []
    }
  },
  watch: {
    currentAutomaticSnapshot(newval) {
      if (newval && newval.length > 0) {
        console.log("ENTER: ", newval)
        this.carouselModel = 2
        this.showAutomaticSnapshot = true
      }
    }
  },
  methods: {
    ...mapActions(["doTakeSnapshot", "doAlarmOnDemand"]),
    ...mapMutations(["mShowLongLoader", "mHideLongLoader", "mShowInfoMessage"]),
    back() {
      this.$router.push({ name: "home" });
    },
    async takeSnapshot(camera) {
      this.showSnapshot = true
      let payload = {
        device: this.$route.params.id,
        cameraid: camera
      }
      let snapshot = await this.doTakeSnapshot(payload)
      console.log(snapshot)
      if (snapshot != null) {
        this.snapshotUrl = snapshot.img
      }
    },
    alarmOnDemand() {
      this.doAlarmOnDemand(this.$route.params.id)
      this.mShowInfoMessage(this.$i18n.t("device.alarmsent"))
    }
  },
  beforeRouteEnter(to, from, next) {
    Vue.$enterUserSignalr().then(next())
  },
  beforeRouteLeave(to, from, next) {
    Vue.$exitUserSignalr().then(next())
  },
};
</script>

<style scoped>
.loadingtext {
  color: white;
}

@keyframes fadein {
  0%,100% { opacity: 0.8 }
  50% { opacity: 1 }
}

.runningImage {
  opacity: 1;
  animation: fadein 2s linear infinite;
}
</style>
